import { useState, useEffect } from 'react';

const useFetch = url => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const key = process.env.REACT_APP_KEY_AUTH;
    async function fetchData() {
      const response = await fetch(url, {
        headers: {
          'api-key': key,
        },
      });
      const json = await response.json();
      setData(json);
      setLoading(false);
    }
    fetchData();
  }, [url]);

  return [data, loading];
};

export default useFetch;
